import {
    ACTION_ADD_NOTIFICATION,
    ACTION_DELETE_NOTIFICATION,
    ACTION_RESET_NOTIFICATION_STORE,
    DEFAULT,
    type NotificationActionTypes,
    type NotificationState,
} from '../types/notification';

export function notifications(state: NotificationState = DEFAULT, action: NotificationActionTypes): NotificationState {
    switch (action.type) {
        case ACTION_RESET_NOTIFICATION_STORE:
            return DEFAULT;
        case ACTION_ADD_NOTIFICATION: {
            const includesNewsNotification = state.some(
                (n) => n.message === action.notification.message && n.severity === action.notification.severity,
            );
            if (!includesNewsNotification) {
                return [action.notification].concat(state);
            }
            return [...state];
        }
        case ACTION_DELETE_NOTIFICATION: {
            const index = state.indexOf(action.notification);
            if (index > -1) {
                state.splice(index, 1);
            }
            return [...state];
        }
        default:
            return state;
    }
}
